// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PageTitle styling elements */
.pagetitle-container {
	background-color: var(--scouting-america-blue);

	padding-left: 40px;
	padding-right: 40px;
	padding-top: 10px;
	padding-bottom: 10px;

	margin-top: 0px;
	margin-bottom: 40px;
	margin-left: auto;
	margin-right: auto;

	max-width: 800px;

	display: flex;
	justify-content: center;
	align-items: center;

	border-radius: 12px;
	border-left: 6px solid var(--scouting-america-red);

	box-shadow:
		0px 0px 20px
		color-mix(in srgb, var(--scouting-america-dark-blue) 80%, transparent);
}

.pagetitle-text {
	margin-top: 0px !important;
	margin-bottom: 0px !important;

	font-size: var(--header-font-size);
	text-align: center;
	letter-spacing: 1px;
}



/* PageCard styling */
.pagecard-container {
	background-color: var(--scouting-america-dark-grey);

	max-width: 1100px;
	width: 99%;

	margin-left: auto;
	margin-right: auto;
	margin-top: 0px;
	margin-bottom: 0px;

	overflow: hidden;
	border-radius: 12px;
	border: 1px solid var(--scouting-america-blue);
	border-top: 8px solid var(--scouting-america-blue);
}

.pagecard-headbar {
	background: linear-gradient(
		to right,
		var(--scouting-america-blue) 10%,
		var(--scouting-america-dark-grey) 90%
	);

	padding-left: 24px;
	padding-right: 24px;
	padding-top: 8px;
	padding-bottom: 16px;
}

.pagecard-headtext {
	color: var(--scouting-america-white);

	margin: 0px;

	font-size: var(--subheader-font-size);
	font-weight: bold;
}

.pagecard-body-ctr {
	background-color: var(--scouting-america-dark-grey);
	
	padding-left: 24px;
	padding-right: 24px;
	padding-top: 30px;
	padding-bottom: 30px;
}

.pagecard-container em {
	color: var(--scouting-america-pale-blue);

	font-weight: bolder;
	font-style: normal;
}

.pagecard-container a {
	color: var(--scouting-america-pale-blue);

	font-weight: bold;

	border-bottom: 2px solid transparent;

	transition: all 0.2s ease;
}
	.pagecard-container a:hover {
		color: var(--scouting-america-red);

		border-bottom: 2px solid var(--scouting-america-red);
	}
	.pagecard-container a:visited {
		color: var(--scouting-america-blue);

		border-bottom: 2px solid var(--scouting-america-blue);
	}`, "",{"version":3,"sources":["webpack://./src/components/PageElements/PageElements.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;CACC,8CAA8C;;CAE9C,kBAAkB;CAClB,mBAAmB;CACnB,iBAAiB;CACjB,oBAAoB;;CAEpB,eAAe;CACf,mBAAmB;CACnB,iBAAiB;CACjB,kBAAkB;;CAElB,gBAAgB;;CAEhB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;;CAEnB,mBAAmB;CACnB,kDAAkD;;CAElD;;wEAEuE;AACxE;;AAEA;CACC,0BAA0B;CAC1B,6BAA6B;;CAE7B,kCAAkC;CAClC,kBAAkB;CAClB,mBAAmB;AACpB;;;;AAIA,qBAAqB;AACrB;CACC,mDAAmD;;CAEnD,iBAAiB;CACjB,UAAU;;CAEV,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,kBAAkB;;CAElB,gBAAgB;CAChB,mBAAmB;CACnB,8CAA8C;CAC9C,kDAAkD;AACnD;;AAEA;CACC;;;;EAIC;;CAED,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;CAChB,oBAAoB;AACrB;;AAEA;CACC,oCAAoC;;CAEpC,WAAW;;CAEX,qCAAqC;CACrC,iBAAiB;AAClB;;AAEA;CACC,mDAAmD;;CAEnD,kBAAkB;CAClB,mBAAmB;CACnB,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;CACC,wCAAwC;;CAExC,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,wCAAwC;;CAExC,iBAAiB;;CAEjB,oCAAoC;;CAEpC,yBAAyB;AAC1B;CACC;EACC,kCAAkC;;EAElC,oDAAoD;CACrD;CACA;EACC,mCAAmC;;EAEnC,qDAAqD;CACtD","sourcesContent":["/* PageTitle styling elements */\n.pagetitle-container {\n\tbackground-color: var(--scouting-america-blue);\n\n\tpadding-left: 40px;\n\tpadding-right: 40px;\n\tpadding-top: 10px;\n\tpadding-bottom: 10px;\n\n\tmargin-top: 0px;\n\tmargin-bottom: 40px;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\n\tmax-width: 800px;\n\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\tborder-radius: 12px;\n\tborder-left: 6px solid var(--scouting-america-red);\n\n\tbox-shadow:\n\t\t0px 0px 20px\n\t\tcolor-mix(in srgb, var(--scouting-america-dark-blue) 80%, transparent);\n}\n\n.pagetitle-text {\n\tmargin-top: 0px !important;\n\tmargin-bottom: 0px !important;\n\n\tfont-size: var(--header-font-size);\n\ttext-align: center;\n\tletter-spacing: 1px;\n}\n\n\n\n/* PageCard styling */\n.pagecard-container {\n\tbackground-color: var(--scouting-america-dark-grey);\n\n\tmax-width: 1100px;\n\twidth: 99%;\n\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tmargin-top: 0px;\n\tmargin-bottom: 0px;\n\n\toverflow: hidden;\n\tborder-radius: 12px;\n\tborder: 1px solid var(--scouting-america-blue);\n\tborder-top: 8px solid var(--scouting-america-blue);\n}\n\n.pagecard-headbar {\n\tbackground: linear-gradient(\n\t\tto right,\n\t\tvar(--scouting-america-blue) 10%,\n\t\tvar(--scouting-america-dark-grey) 90%\n\t);\n\n\tpadding-left: 24px;\n\tpadding-right: 24px;\n\tpadding-top: 8px;\n\tpadding-bottom: 16px;\n}\n\n.pagecard-headtext {\n\tcolor: var(--scouting-america-white);\n\n\tmargin: 0px;\n\n\tfont-size: var(--subheader-font-size);\n\tfont-weight: bold;\n}\n\n.pagecard-body-ctr {\n\tbackground-color: var(--scouting-america-dark-grey);\n\t\n\tpadding-left: 24px;\n\tpadding-right: 24px;\n\tpadding-top: 30px;\n\tpadding-bottom: 30px;\n}\n\n.pagecard-container em {\n\tcolor: var(--scouting-america-pale-blue);\n\n\tfont-weight: bolder;\n\tfont-style: normal;\n}\n\n.pagecard-container a {\n\tcolor: var(--scouting-america-pale-blue);\n\n\tfont-weight: bold;\n\n\tborder-bottom: 2px solid transparent;\n\n\ttransition: all 0.2s ease;\n}\n\t.pagecard-container a:hover {\n\t\tcolor: var(--scouting-america-red);\n\n\t\tborder-bottom: 2px solid var(--scouting-america-red);\n\t}\n\t.pagecard-container a:visited {\n\t\tcolor: var(--scouting-america-blue);\n\n\t\tborder-bottom: 2px solid var(--scouting-america-blue);\n\t}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
